import React from 'react';

export const ButtonsContainer = ({ children }) => (
  <div className="flex justify-center pt-4 pb-12">
    {children}
  </div>
)
